/* eslint-disable class-methods-use-this */
import { PagedResultDto } from '../dto/pagedResultDto';
import http from '../httpService';
import {
  BulkReceivePurchaseOrder,
  CreatePurchaseOrder,
  GetAllPurchaseOrdersInput,
  ParsedInvoice,
  PurchaseOrder,
  PurchaseOrderMatchResult,
  ReceivePurchaseOrder,
  UpdatePurchaseOrder,
} from './dto/purchaseOrder';

class PurchaseOrderService {
  public async getAll(request: GetAllPurchaseOrdersInput): Promise<PagedResultDto<PurchaseOrder>> {
    const result = await http.get('api/services/app/PurchaseOrder/GetAll', { params: request });
    return result.data.result;
  }

  public async get(id: string): Promise<PurchaseOrder> {
    const result = await http.get('api/services/app/PurchaseOrder/Get', { params: { id } });
    return result.data.result;
  }

  public async create(input: CreatePurchaseOrder): Promise<PurchaseOrder> {
    const result = await http.post('api/services/app/PurchaseOrder/Create', input);
    return result.data.result;
  }

  public async update(input: UpdatePurchaseOrder): Promise<PurchaseOrder> {
    const result = await http.put('api/services/app/PurchaseOrder/Update', input);
    return result.data.result;
  }

  public async delete(id: string): Promise<void> {
    await http.delete('api/services/app/PurchaseOrder/Delete', { params: { id } });
  }

  public async markOrdered(id: string): Promise<void> {
    await http.post(`api/services/app/PurchaseOrder/MarkOrdered?id=${id}`);
  }

  public async receive(input: ReceivePurchaseOrder): Promise<void> {
    await http.post('api/services/app/PurchaseOrder/Receive', input);
  }

  public async cancel(id: string): Promise<void> {
    await http.post(`api/services/app/PurchaseOrder/Cancel?id=${id}`);
  }

  public async parseInvoice(request: {
    name: string;
    content: string;
    contentType: string;
    categoryNames?: string[];
  }): Promise<ParsedInvoice> {
    const result = await http.post('api/services/app/PurchaseOrder/ParseInvoice', request, {
      timeout: 120000,
    });
    return result.data.result;
  }

  public async matchInvoice(input: {
    supplierId: string;
    lines: ParsedInvoice['lineItems'];
  }): Promise<PurchaseOrderMatchResult[]> {
    const result = await http.post('api/services/app/PurchaseOrder/MatchInvoice', input);
    return result.data.result;
  }

  public async bulkReceive(input: BulkReceivePurchaseOrder): Promise<void> {
    await http.post('api/services/app/PurchaseOrder/BulkReceive', input);
  }
}

export default new PurchaseOrderService();
